/*
 * File: Constants.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on May 31, 2025 at 5:33 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 31, 2025 at 5:33 PM
 * Modified By: Brendan Michaelsen
 */

export const LEGAL_NAVIGATION_SECTIONS = (locale) => [
	{
		title: 'Terms',
		links: [
			{
				label: 'Terms of Service',
				url: '/legal/terms'
			}
		]
	},
	{
		title: 'Policies',
		links: [
			{
				label: 'Privacy Policy',
				url: '/legal/privacy'
			},
			{
				label: 'Cookie Statement',
				url: '/legal/cookie-statement'
			},
			{
				label: 'Community Guidelines',
				url: '/legal/community-guidelines'
			},
			{
				label: 'Review Guidelines',
				url: '/legal/review-guidelines'
			}
		]
	},
	{
		title: 'General',
		links: [
			{
				label: 'Accessibility Commitment',
				url: '/legal/accessibility'
			},
			{
				label: 'Security Promise',
				url: `https://www.ourwave.org${locale.localePath}/security`
			}
		]
	}
];
